"use client";

import { useCallback, useState } from "react";

export function useScrollMask() {
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const updateMask = useCallback((el: HTMLElement) => {
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setAtStart(scrollLeft <= 1);
    setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
  }, []);

  const ref = useCallback(
    (el: HTMLDivElement | null) => {
      if (!el) return;
      updateMask(el);
      el.addEventListener("scroll", () => updateMask(el), { passive: true });
    },
    [updateMask],
  );

  const maskImage = atStart
    ? atEnd
      ? "none"
      : "linear-gradient(to right, black 95%, transparent)"
    : atEnd
      ? "linear-gradient(to right, transparent, black 5%)"
      : "linear-gradient(to right, transparent, black 5%, black 95%, transparent)";

  return { ref, maskImage };
}
